var DeveloperPlansService = /** @class */ (function () {
    function DeveloperPlansService(api) {
        var _this = this;
        this.listDeveloperPlans = function () {
            var url = "/devplan";
            return _this.API.get(url);
        };
        this.listSignupFlows = function () {
            var url = "/devplan/flow";
            return _this.API.get(url);
        };
        this.getSignupFlow = function (flowId) {
            var url = "/devplan/flow/".concat(flowId);
            return _this.API.get(url);
        };
        this.getSignupFlowDevs = function (campaignName, orgID) {
            var url = "/devplan/campaign";
            if (campaignName) {
                url = "".concat(url, "?name=").concat(campaignName);
            }
            if (orgID) {
                url = campaignName ? "".concat(url, "&orgID=").concat(orgID) : "".concat(url, "?orgID=").concat(orgID);
            }
            return _this.API.get(url);
        };
        this.getDeveloperPlans = function (devPlanId) {
            var url = "/devplan/".concat(devPlanId);
            return _this.API.get(url);
        };
        this.listDeveloperPlansOrg = function (orgId) {
            var url = "/devplan/organization?id=".concat(orgId);
            return _this.API.get(url);
        };
        this.getConsumedPublishing = function (appId) {
            /*not used*/
            var url = "/devplan/consumption/publishing?app=".concat(appId);
            return _this.API.get(url);
        };
        this.listDeveloperPlanBundles = function (devPlanId) {
            /*not used*/
            var url = "/devplan/".concat(devPlanId, "/bundles");
            return _this.API.get(url);
        };
        this.purchaseDeveloperPlansOrg = function (orgId, devPlanId, bundle) {
            var url = "/devplan/purchase?organization=".concat(orgId);
            return _this.API.post(url, {
                top_up_bundles: bundle || [],
                dev_plan: devPlanId,
            });
        };
        this.updatePurchaseDeveloperPlansOrg = function (orgId, bundles) {
            //Not used
            var url = "/devplan/purchase/update?organization=".concat(orgId);
            return _this.API.post(url, bundles || []);
        };
        this.createSignupFlow = function (flow) {
            var url = "/devplan/flow";
            return _this.API.post(url, flow);
        };
        this.createDeveloperPlan = function (devPlan) {
            var url = "/devplan";
            return _this.API.post(url, devPlan);
        };
        this.updateSignupFlow = function (flowId, flow) {
            var url = "/devplan/flow/".concat(flowId);
            return _this.API.patch(url, flow);
        };
        this.updateDeveloperPlan = function (devPlanId, devPlan) {
            var url = "/devplan/".concat(devPlanId);
            return _this.API.patch(url, devPlan);
        };
        this.setDefaultSignupFlow = function (signupFlowId, signupFlow) {
            var url = "/devplan/flow/".concat(signupFlowId, "/default");
            return _this.API.patch(url, {
                name: signupFlow.name,
                valid_from: signupFlow.valid_from,
                valid_until: signupFlow.valid_until,
            });
        };
        this.getDeleteConfirmSignupFlow = function (signupFlowId) {
            return _this.API.get("/devplan/flow/".concat(signupFlowId, "/delete"));
        };
        this.deleteDeveloperPlan = function (devPlanId) { return _this.API.delete("/devplan/".concat(devPlanId)); };
        this.getDeleteConfirmationDeveloperPlan = function (devPlanId) {
            var url = "/devplan/".concat(devPlanId, "/delete");
            return _this.API.get(url);
        };
        this.cancelDevPlan = function (orgId) {
            var url = "/devplan/subscription/cancel?organization=".concat(orgId);
            return _this.API.patch(url);
        };
        this.reactivateDevPlan = function (orgId) {
            var url = "/devplan/subscription/reactivate?organization=".concat(orgId);
            return _this.API.patch(url);
        };
        this.deleteSignupFlows = function (signupFlowId) {
            return _this.API.delete("/devplan/flow/".concat(signupFlowId));
        };
        this.getDevPlanInvloiceDetails = function (orgId) {
            var url = "/organizations/".concat(orgId, "/invoice");
            return _this.API.get(url);
        };
        this.getProRatedAmount = function (orgId, devPlanId) {
            var url = "/organizations/".concat(orgId, "/devplan/").concat(devPlanId, "/proration");
            return _this.API.get(url);
        };
        //Reseller - Managed Org
        this.getManageDevPlanByResellerId = function (resellerOrgId, managedOrgId) {
            return _this.API.get("/resellers/".concat(resellerOrgId, "/managed/").concat(managedOrgId, "/devplans"));
        };
        this.getManagedOrgDevPlanStatus = function (resellerOrgId, managedOrgId) {
            var url = "/resellers/".concat(resellerOrgId, "/managed/").concat(managedOrgId, "/devplan/status");
            return _this.API.get(url);
        };
        this.updatePurchaseDeveloperPlansManagedOrg = function (resellerOrgId, managedOrgId, bundles) {
            // not used
            var url = "/resellers/".concat(resellerOrgId, "/managed/").concat(managedOrgId, "/devplan/purchase/update");
            return _this.API.patch(url, bundles || []);
        };
        this.cancelManagedOrgDevPlan = function (resellerOrgId, managedOrgId) {
            var url = "/resellers/".concat(resellerOrgId, "/managed/").concat(managedOrgId, "/devplan/subscription/cancel");
            return _this.API.patch(url);
        };
        this.reactivateManagedOrgDevPlan = function (resellerOrgId, managedOrgId) {
            var url = "/resellers/".concat(resellerOrgId, "/managed/").concat(managedOrgId, "/devplan/subscription/reactivate");
            return _this.API.patch(url);
        };
        this.purchaseDeveloperPlansManagedOrg = function (resellerOrgId, managedOrgId, devPlanId, bundle) {
            var url = "/resellers/".concat(resellerOrgId, "/managed/").concat(managedOrgId, "/devplan/purchase");
            return _this.API.post(url, {
                top_up_bundles: bundle || [],
                dev_plan: devPlanId,
            });
        };
        this.getManagedOrgDevPlanInvloiceDetails = function (resellerOrgId, managedOrgId) {
            var url = "/resellers/".concat(resellerOrgId, "/managed/").concat(managedOrgId, "/invoice");
            return _this.API.get(url);
        };
        this.getManagedOrgProRatedAmount = function (resellerOrgId, managedOrgId, devPlanId) {
            var url = "/resellers/".concat(resellerOrgId, "/managed/").concat(managedOrgId, "/devplan/").concat(devPlanId, "/proration");
            return _this.API.get(url);
        };
        this.API = api;
    }
    return DeveloperPlansService;
}());
export { DeveloperPlansService };
